import {
  ControlPosition,
  StreetViewControlOptions,
  ZoomControlOptions,
  ZoomControlStyle,
} from '@agm/core/services/google-maps-types';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../config/config';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { SideFloatComponent } from '../../../../common/components/side.float/side.float.component';
import { bindFunctionsToThis, isNullOrUndefined } from '../../../../common/extensions';
import { popupCenter } from '../../../../common/extensions/browser/browser.extensions';
import { GoogleMapsService, TravelMode } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { HubTour } from '../../../../models/hub/hub.tour';
import { ImageService } from '../../../../services/image.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { TravelModeStore, VisitorDataCache, VisitorTripStore } from '../../../../stores/visitor.calendar.store';
import { TripMapBottomInfoComponent } from '../../../visitor/trip/trip.map.bottom.info/trip.map.bottom.info.component';
import { AlertifyService } from '../../../../services/alertify.service';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'ig-direction-plan',
  templateUrl: './direction.plan.component.html',
  styleUrls: [
    './direction.plan.component.scss',
    '../../../../../node_modules/snazzy-info-window/dist/snazzy-info-window.css',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DirectionPlanComponent extends BaseComponent implements OnInit {
  public hubName = '';
  public direction = 'Getting directions...';
  public travelMode: TravelMode = TravelMode.DRIVING;
  public canChangeTravelMode = true;
  public time = '';
  public distance = '';
  public isStarted = false;
  public isReady = false;
  public route: any;
  public searchFormGroup: FormGroup;
  public searchParam = {
    searchFormGroup: FormGroup,
    searchText: '',
    searchResult: [],
    searchTimeout: null,
    isShowSearchResult: false,
    isNoResult: false,
  };
  public noMoreNext = false;
  public noMorePrevious = true;
  public bigStopIndex = 0;
  public smallStepIndex = 0;
  public directions: any;
  public currentIndex: any;
  public isInfoWindowsOpen: any[];
  public tripPlannerMapMarker = config.tripPlannerMapMarkerNoOverlap; //ConfigService.config.tripPlannerMapMarkerNoOverlap;
  public hideIconMapStyler = config.google.hideMapBusinessIconStyles; //ConfigService.config.google.hideMapBusinessIconStyles;
  public lat: number = config.google.USCenter.lat; //ConfigService.config.google.USCenter.lat;
  public lng: number = config.google.USCenter.lng; //ConfigService.config.google.USCenter.lng;
  public latLngBounds: any;
  public zoomOptions: ZoomControlOptions = {
    position: ControlPosition.LEFT_BOTTOM,
    style: ZoomControlStyle.SMALL,
  };
  public streetViewOptions: StreetViewControlOptions = {
    position: ControlPosition.LEFT_BOTTOM,
  };

  @Input() tour: HubTour;
  @Input() type: string;
  @Input() canSetDefaultTravelMode = false;
  @ViewChild('mapBottomInfo') public mapBottomInfo: TripMapBottomInfoComponent;
  @ViewChild('sidefloat') public sideFloat: SideFloatComponent;
  @ViewChild('banner') public banner: ElementRef;
  @ViewChild('defaultTravelModeMenuTrigger') defaultTravelModeMenuTrigger: MatMenuTrigger;
  @Output() onStart: EventEmitter<any> = new EventEmitter();
  @Output() onEnd: EventEmitter<any> = new EventEmitter();
  @Output() showDetail: EventEmitter<any> = new EventEmitter();
  @Output() removeFromTrip: EventEmitter<any> = new EventEmitter();
  @Output() mapClick: EventEmitter<any> = new EventEmitter();
  @Output() mapReady: EventEmitter<any> = new EventEmitter();
  @Output() enterFirstTrip: EventEmitter<any> = new EventEmitter();

  constructor(
    private googleMapService: GoogleMapsService,
    private imageService: ImageService,
    private activatedRoute: ActivatedRoute,
    private visitorTripStore: VisitorTripStore,
    private travelModeStore: TravelModeStore,
    private visitorApiService: VisitorApiService,
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private alertify: AlertifyService,
    private ngZone: NgZone
  ) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    bindFunctionsToThis(this);
    this.isInfoWindowsOpen = [];
    this.searchFormGroup = this.formBuilder.group({
      search: [null],
    });
    if (!!this.tour) {
      console.log(this.tour);
      if (!this.tour.defaultTravelMode) {
        this.tour.defaultTravelMode = {
          mode: TravelMode.DRIVING,
          canChange: true,
        };
      }
      this.travelMode = this.tour.defaultTravelMode.mode as TravelMode;
      this.canChangeTravelMode = this.tour.defaultTravelMode.canChange;
      this.travelModeStore.modeCommand.next(this.travelMode);

      if (!this.tour.isEventImageProcessed) {
        this.getEventsFromCache().subscribe((events) => {
          this.processDefaultImages();
          this.drawFullRoute();
          this.tour.attractions.forEach((x) => {
            this.isInfoWindowsOpen.push(false);
          });
        });
      } else {
        this.drawFullRoute();
        this.tour.attractions.forEach((x) => {
          this.isInfoWindowsOpen.push(false);
        });
      }
    }

    this.visitorTripStore.tripCommand.takeUntil(this.isDestroyed).subscribe((item) => {
      if (!isNullOrUndefined(item.item)) {
        let targetIndex = 0;
        this.tour.attractions.forEach((x, index) => {
          this.isInfoWindowsOpen[index] = false;
          if (x.item._id === item.item._id) {
            targetIndex = index;
            return;
          }
        });
        setTimeout(() => {
          this.isInfoWindowsOpen[targetIndex] = true;
        });
      }
    });

    // this.travelModeStore.modeCommand.takeUntil(this.isDestroyed)
    //     .subscribe((mode: TravelMode) => {
    //         if (mode !== this.travelMode) {
    //             this.stopPlan();
    //             this.travelMode = mode;
    //             this.drawFullRoute();
    //         }
    //     });

    if (this.type === 'tour') {
      this.hideBanner();
    }
  }

  public get canChangeTravelModeOnFrontend() {
    return !this.isStarted && this.canChangeTravelMode && !this.canSetDefaultTravelMode;
  }

  public get getZoom() {
    if (!this.tour || !this.tour.attractions) return 4;
    return !this.tour.attractions.length ? 4 : this.tour.attractions.length === 1 ? 17 : 0;
  }

  public enterFirstTripTrigger($event) {
    $event.stopPropagation();
    this.enterFirstTrip.emit();
  }

  public showBanner() {
    setTimeout(() => {
      this.banner.nativeElement.style.color = 'white';
      this.banner.nativeElement.style.height = '40px';
    });
  }

  public hideBanner() {
    setTimeout(() => {
      this.banner.nativeElement.style.color = 'transparent';
      this.banner.nativeElement.style.height = '0';
    });
  }

  public search() {
    if (this.searchParam.searchTimeout) {
      clearTimeout(this.searchParam.searchTimeout);
      this.searchParam.searchTimeout = setTimeout(() => {
        this.searchAttraction();
      }, 300);
      return;
    }

    this.searchParam.searchTimeout = setTimeout(() => {
      this.searchAttraction();
    }, 300);
  }

  public onMapClick() {
    this.mapClick.emit();
  }

  public closeSideFloat() {
    this.sideFloat.close();
  }

  public popup() {
    this.googleMapService.getUserGPSLocation().subscribe(
      (gps) => {
        gps.lat = 34.087926733422;
        gps.lng = -118.24855797032;

        let addresses = [];
        for (let x of this.tour.attractions) {
          if (x.item.address) {
            let address = x.item.address.address || x.item.address;
            addresses.push(address.replaceAll(' ', '+'));
          }
        }
        let stops = addresses.join('/');

        let navigationUrl = config.google.navigation.replace('${GPS}', `${gps.lat},${gps.lng}`);
        navigationUrl = navigationUrl.replace('${addresses}', stops);

        popupCenter(navigationUrl);
      },
      (error) => {
        if (error) {
          alert(`GPS error: ${error}, error.code: ${error.code}, error.message: ${error.message}`);
        } else {
          alert(`GPS error, no details`);
        }

        let addresses = [];
        for (let x of this.tour.attractions) {
          if (x.item.address) {
            let address = x.item.address.address || x.item.address;
            addresses.push(address.replaceAll(' ', '+'));
          }
        }
        let stops = addresses.join('/');

        let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
        navigationUrl = navigationUrl.replace('${addresses}', stops);

        popupCenter(navigationUrl);
      }
    );
  }

  public fromThen() {
    let newWindow = window.open('', '_blank');
    setTimeout(() => {
      window.focus();
    });
    this.googleMapService
      .getUserLocation()
      .then(() => {
        let addresses = [];
        for (let x of this.tour.attractions) {
          if (x.item.address) {
            let address = x.item.address.address || x.item.address;
            addresses.push(address.replaceAll(' ', '+'));
          }
        }
        let stops = addresses.join('/');

        let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
        navigationUrl = navigationUrl.replace('${addresses}', stops);

        newWindow.focus();
        newWindow.location.href = navigationUrl;
      })
      .catch(() => {
        let addresses = [];
        for (let x of this.tour.attractions) {
          if (x.item.address) {
            let address = x.item.address.address || x.item.address;
            addresses.push(address.replaceAll(' ', '+'));
          }
        }
        let stops = addresses.join('/');

        let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
        navigationUrl = navigationUrl.replace('${addresses}', stops);

        newWindow.focus();
        newWindow.location.href = navigationUrl;
      });
  }

  public getGPS() {
    let newWindow = window.open('', '_blank');
    setTimeout(() => {
      window.focus();
    });
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // alert(`from getGPS: ${position.coords.latitude}, ${position.coords.longitude}`);
        const lat = 34.087926733422; //position.coords.latitude;
        const lng = -118.24855797032; //position.coords.longitude;

        let addresses = [];
        for (let x of this.tour.attractions) {
          if (x.item.address) {
            let address = x.item.address.address || x.item.address;
            addresses.push(address.replaceAll(' ', '+'));
          }
        }
        let stops = addresses.join('/');

        let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
        navigationUrl = navigationUrl.replace('${addresses}', stops);
        // window.open(navigationUrl, '_blank');
        //
        // alert(navigationUrl);

        newWindow.focus();
        newWindow.location.href = navigationUrl;
      },
      (error) => {
        alert('Unable to retrieve your location!' + 'ERROR(' + error.code + '): ' + error.message);

        const lat = 34.087926733422; //position.coords.latitude;
        const lng = -118.24855797032; //position.coords.longitude;

        let addresses = [];
        for (let x of this.tour.attractions) {
          if (x.item.address) {
            let address = x.item.address.address || x.item.address;
            addresses.push(address.replaceAll(' ', '+'));
          }
        }
        let stops = addresses.join('/');

        let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
        navigationUrl = navigationUrl.replace('${addresses}', stops);
        // window.open(navigationUrl, '_blank');
        //
        // alert(navigationUrl);

        newWindow.focus();
        newWindow.location.href = navigationUrl;
      }
    );
  }

  public getUserLocation($event) {
    let addresses = [];
    for (let x of this.tour.attractions) {
      if (x.item.address) {
        let address = x.item.address.address || x.item.address;
        addresses.push(address.replaceAll(' ', '+'));
      }
    }
    let stops = addresses.join('/');

    let navigationUrl = config.google.navigation.replace('${addresses}', stops);

    localStorage.setItem('gps-url', navigationUrl);

    let urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
    urlBase = urlBase.substr(0, urlBase.lastIndexOf('/'));
    window.open(`${urlBase}/gps-redirect/`, '_blank');

    $event.complete();
    this.sideFloat.close();

    // newWindow.document.write("<html><head></head><body>Please wait while we redirect you</body></html>");
    // newWindow.document.close();
    // newWindow.location.href = "";
    //
    // setTimeout(() => {
    //     window.focus();
    // });
    //
    // this.googleMapService.getUserGPSLocation().subscribe(gps => {
    //     // gps.lat = 34.087926733422;
    //     // gps.lng = -118.24855797032;
    //
    //     // let addresses = [];
    //     // for (let x of this.tour.attractions) {
    //     //     if (x.item.address) {
    //     //         let address = x.item.address.address || x.item.address;
    //     //         addresses.push(address.replaceAll(' ', '+'));
    //     //     }
    //     // }
    //     // let stops = addresses.join('/');
    //     //
    //     // let navigationUrl = config.google.navigation.replace('${GPS}', `${gps.lat},${gps.lng}`);
    //     // navigationUrl = navigationUrl.replace('${addresses}', stops);
    //
    //     newWindow.focus();
    //     newWindow.location.href = navigationUrl;
    //
    //     $event.complete();
    //     this.sideFloat.close();
    // }, (error) => {
    //
    //     // if (error) {
    //     //     alert(`GPS error: ${error}, error.code: ${error.code}, error.message: ${error.message}`);
    //     // } else {
    //     //     alert(`GPS error, no details`);
    //     // }
    //     //
    //     // let addresses = [];
    //     // for (let x of this.tour.attractions) {
    //     //     if (x.item.address) {
    //     //         let address = x.item.address.address || x.item.address;
    //     //         addresses.push(address.replaceAll(' ', '+'));
    //     //     }
    //     // }
    //     // let stops = addresses.join('/');
    //     //
    //     // let navigationUrl = config.google.navigation.replace('${GPS}', `27.674044,-82.175407`);
    //     // navigationUrl = navigationUrl.replace('${addresses}', stops);
    //     //
    //     // newWindow.focus();
    //     // newWindow.location.href = navigationUrl;
    //
    //     $event.complete();
    //     this.sideFloat.close();
    // });
  }

  private searchAttraction() {
    this.searchParam.isNoResult = false;
    //this.searchParam.isShowSearchResult = false;
    if (this.searchParam.searchText) {
      this.searchParam.searchResult = this.tour.attractions.filter(
        (x) => x.item.name.toLowerCase().indexOf(this.searchParam.searchText.toLowerCase()) >= 0
      );
      if (!this.searchParam.searchResult || !this.searchParam.searchResult.length) {
        this.searchParam.isNoResult = true;
      }
      this.searchParam.isShowSearchResult = true;
      window.addEventListener('click', this.closeSearchResult);
    }
  }

  private closeSearchResult() {
    this.searchParam.isShowSearchResult = false;
  }

  public ready() {
    this.isReady = true;
    this.mapReady.emit();
  }

  public notReady() {
    this.isReady = false;
  }

  public setTour(tour) {
    this.tour = tour;
  }

  public drawFullRoute() {
    if (!this.tour.attractions.length) {
      this.directions = null;
      this.lat = config.google.USCenter.lat;
      this.lng = config.google.USCenter.lng;
      return;
    }
    if (this.tour.attractions.length === 1) {
      this.directions = null;
      this.lat = this.tour.attractions[0].item.address.lat || this.tour.attractions[0].item.lat;
      this.lng = this.tour.attractions[0].item.address.lng || this.tour.attractions[0].item.lng;
      //this.fitBounds();
      return;
    }

    let items = [];
    this.tour.attractions.forEach((x) => {
      items.push(x.item);
    });

    this.googleMapService.getFullRoute(items).subscribe((data) => {
      this.directions = data;
      this.ready();
      this.fitBounds();
    });
  }

  public drawFullRouteWithUserLocation(lat, lng) {
    if (!this.tour.attractions.length) {
      this.directions = null;
      this.lat = config.google.USCenter.lat;
      this.lng = config.google.USCenter.lng;
      return;
    }

    let event = {
      title: 'GPS',
      address: {
        lat: 34.076926733422, //lat, //34.076926733422,
        lng: -118.23855797032, //lng, //-118.23855797032
      },
    };
    let items = [];
    items.push(event);
    this.tour.attractions.forEach((x) => {
      items.push(x.item);
    });

    this.googleMapService.getFullRoute(items).subscribe((data) => {
      this.directions = data;
      this.ready();
      this.fitBounds();
    });
  }

  public startGPSPlan() {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.gpsRedirect();
        event && event.complete();
      },
      cancel: () => {
        this.startPlan();
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'help',
      confirmModalTitle: '',
      confirmModalDescription: `Do you want to start this ${
        this.type === 'trip' ? 'trip' : 'itinerary'
      } from your current location?`,
      confirmModalConfirmButtonText: 'Yes',
      confirmModalCancelButtonText: 'No',
      isAsync: true,
      color: 'primary',
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        {provide: ConfirmModalActions, useValue: actions},
        {provide: ConfirmModalData, useValue: data},
      ],
      panelClass: 'ig-start-gps-modal',
    });
  }

  // public startOrStopPlan() {
  //     this.isStarted ? this.stopPlan() : this.startGPSPlan();
  // }
  public startOrStopPlan(mode?: TravelMode | string) {
    if (mode) {
      this.travelMode = mode as TravelMode;
    }
    this.startGPSPlan();
    this.travelModeStore.modeCommand.next(this.travelMode);
  }

  public startPlan() {
    if (!this.isReady) {
      return;
    }

    this.direction = 'Getting directions...';
    this.time = '';
    this.distance = '';
    this.isStarted = true;
    this.bigStopIndex = 0;
    this.smallStepIndex = 0;
    this.onStart.emit();
    this.googleMapService.getDirection(this.tour.attractions, this.travelMode, (response) => {
      this.ngZone.run(() => {
        this.route = response;
        this.noMorePrevious = true;
        this.noMoreNext = false;
        this.setDirectionText();
        this.setDirectionSegment(true);
      });
      //this.smallStepIndex = 1;
    });
  }

  public stopPlan() {
    this.isStarted = false;
    this.drawFullRoute();
    this.onEnd.emit();
  }

  public previous() {
    if (this.noMorePrevious) {
      return;
    }

    let segmentChanged = false;
    if (this.smallStepIndex > 0) {
      this.smallStepIndex--;
      if (this.smallStepIndex === 0 && this.bigStopIndex === 0) {
        this.noMorePrevious = true;
      }
    } else {
      if (this.bigStopIndex > 0) {
        this.bigStopIndex--;
        segmentChanged = true;
        this.smallStepIndex = this.route.legs[this.bigStopIndex].steps.length - 1;
        if (this.bigStopIndex === 0 && this.smallStepIndex === 0) {
          this.noMorePrevious = true;
        }
      } else {
        this.noMorePrevious = true;
        return;
      }
    }
    this.noMoreNext = false;
    this.setDirectionText();
    if (segmentChanged) {
      this.setDirectionSegment(false);
    }
  }

  public next() {
    if (this.noMoreNext) {
      return;
    }

    let segmentChanged = false;
    if (this.smallStepIndex < this.route.legs[this.bigStopIndex].steps.length - 1) {
      this.smallStepIndex++;
      if (
        this.bigStopIndex === this.route.legs.length - 1 &&
        this.smallStepIndex === this.route.legs[this.bigStopIndex].steps.length - 1
      ) {
        this.noMoreNext = true;
      }
    } else {
      this.smallStepIndex = 0;
      if (this.bigStopIndex < this.route.legs.length - 1) {
        this.bigStopIndex++;
        segmentChanged = true;
        if (
          this.bigStopIndex === this.route.legs.length - 1 &&
          this.smallStepIndex === this.route.legs[this.bigStopIndex].steps.length - 1
        ) {
          this.noMoreNext = true;
        }
      } else {
        this.noMoreNext = true;
        return;
      }
    }
    this.noMorePrevious = false;
    this.setDirectionText();
    if (segmentChanged) {
      this.setDirectionSegment(true);
    }
  }

  public onTravelModeChange() {
    if (!this.canSetDefaultTravelMode) {
      setTimeout(() => {
        this.travelModeStore.modeCommand.next(this.travelMode);
        this.defaultTravelModeMenuTrigger.closeMenu();
      });
    }
  }

  public setDefaultTravelMode() {
    this.visitorApiService
      .setDefaultTravelMode(this.hubName, this.tour._id, this.travelMode, this.canChangeTravelMode)
      .subscribe(() => {
        this.alertify.successfully('Set default travel mode');
        this.defaultTravelModeMenuTrigger.closeMenu();
        this.travelModeStore.modeCommand.next(this.travelMode);
      });
  }

  private gpsRedirect() {
    let waypoints = [];
    let destination = '';

    for (let i = 0; i < this.tour.attractions.length; i++) {
      const x = this.tour.attractions[i];
      if (x.item.address) {
        let address = x.item.address.address || x.item.address;
        address = address.replaceAll(' ', '+');
        address = address.replaceAll('null,', '');

        if (i === this.tour.attractions.length - 1) {
          destination = address;
        } else {
          waypoints.push(address);
        }
      }
    }

    let stops = waypoints.join('|');

    let navigationUrl = config.google.navigationApiShort.replace('${waypoints}', stops);
    navigationUrl = navigationUrl.replace('${mode}', this.travelMode.toLowerCase());
    navigationUrl = navigationUrl.replace('${destination}', destination);
    console.log('navigationUrl', navigationUrl);
    localStorage.setItem('gps-url', navigationUrl);

    // let urlBase = window.location.href.substr(0, window.location.href.indexOf('/trips'));
    // urlBase = urlBase.substr(0, urlBase.lastIndexOf('/'));

    window.open(`${config.serverDomain}gps-redirect/${encodeURIComponent(navigationUrl)}`, '_blank');
  }

  private setDirectionText() {
    let leg = this.route.legs[this.bigStopIndex];
    this.direction = leg.steps[this.smallStepIndex].instructions;
    this.time = leg.steps[this.smallStepIndex].duration.text;
    this.distance = leg.steps[this.smallStepIndex].distance.text;
  }

  private setDirectionSegment(isNext: boolean) {
    let start = 0;
    let stop = 0;
    if (isNext) {
      if (this.bigStopIndex >= this.tour.attractions.length - 1) {
        return;
      }
      start = this.bigStopIndex;
      stop = this.bigStopIndex + 1;
    }
    if (!isNext) {
      if (this.bigStopIndex < 0) {
        return;
      }
      start = this.bigStopIndex;
      stop = this.bigStopIndex + 1;
    }

    let startLat = this.tour.attractions[start].item.address.lat || this.tour.attractions[start].item.lat;
    let startLng = this.tour.attractions[start].item.address.lng || this.tour.attractions[start].item.lng;
    let stopLat = this.tour.attractions[stop].item.address.lat || this.tour.attractions[stop].item.lat;
    let stopLng = this.tour.attractions[stop].item.address.lng || this.tour.attractions[stop].item.lng;

    this.directions = {
      origin: {
        lat: startLat,
        lng: startLng,
      },
      destination: {
        lat: stopLat,
        lng: stopLng,
      },
      waypoints: [],
      options: {
        suppressMarkers: true,
        draggable: false,
        // markerOptions: {
        //     icon: ''
        // }
      },
    };
  }

  public showInfoWindowByIndex(index: number) {
    this.hideAllSingleInfoWindow();
    this.currentIndex = index;

    if (!this.isMobile) {
      setTimeout(() => {
        this.isInfoWindowsOpen[index] = true;
      });
    } else {
      setTimeout(() => {
        this.mapBottomInfo.show();
      });
    }
  }

  public gotoDetails(item) {
    this.showDetail.emit(item);
  }

  public remove(item) {
    this.removeFromTrip.emit(item);
    this.currentIndex = null;
  }

  private hideAllSingleInfoWindow() {
    for (let i = 0; i < this.isInfoWindowsOpen.length; i++) {
      this.isInfoWindowsOpen[i] = false;
    }
  }

  public isNullOrUndefined(value) {
    return isNullOrUndefined(value);
  }

  private fitBounds() {
    let items = [];
    this.tour.attractions.forEach((x) => {
      items.push(x.item);
    });
    this.googleMapService.fitBounds(items).subscribe((data) => {
      this.latLngBounds = data;
    });
  }

  private getEventsFromCache(): Observable<any> {
    return Observable.create((observable) => {
      let events = VisitorDataCache.events;
      if (events && events.length) {
        observable.next(events);
        observable.complete();
      } else {
        this.visitorApiService
          .getEvents(this.hubName, {
            limit: config.searchLimit,
            page: 1,
            category: 'all',
          })
          .subscribe((data) => {
            VisitorDataCache.events = data;
            observable.next(data);
            observable.complete();
          });
      }
    });
  }

  private processDefaultImages() {
    this.tour.attractions.forEach((x, index) => {
      // for those events use default images, need to load image from events cache
      if (!x.item.cover) {
        for (let event of VisitorDataCache.events) {
          if (event._id === x.item._id) {
            x.item.cover = event.cover;
            break;
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/direction.plan/direction.plan.component.ts